export function defaultBehaviour(axiosCall, okCallback, koCallback) {
    return axiosCall.then((response) => {
        okCallback && okCallback(response);
    }).catch((error) => {
        koCallback && koCallback(error.response);
    });
}
